import { createSlice } from '@reduxjs/toolkit'
import React from 'react'
import { URL } from '../../config';
     

     
let initialState={ 
    success:'',
    error:''
}

export const MessageSlice =  createSlice({
  name: 'message',
  initialState,
  reducers: {
  
    setSuccessMessage: (state,action) => {     
       state.success=action.payload;  
    },
    setErrorMessage: (state,action) => {   
       state.error=action.payload; 
    },

  },
})
export const {setSuccessMessage,setErrorMessage}=MessageSlice.actions
export default MessageSlice.reducer